export const FOUR_SECONDS = 4000;
